import type { CharacterPhase } from './CharacterPopulationAdapter.js';

/** Footer actions for the character step. Return-from-location adds a way back. */
export function CharacterStepActions(props: {
  phase: CharacterPhase;
  continueDisabled: boolean | null;
  loading: boolean;
  activeCount: number;
  continueLabel: string;
  onContinueForm: () => void;
  onContinueStep: () => void;
  onSaveEdits: (() => void) | null;
}): JSX.Element {
  const formOwnsContinue = props.continueDisabled !== null;
  const hideStepContinue = props.phase === 'detailed' || props.activeCount < 1;
  const hideAllContinue = props.phase === 'traits' || (props.phase === 'editing' && !formOwnsContinue);
  return (
    <>
      {props.onSaveEdits && props.phase === 'basic' && (
        <button type="button" className="btn-primary" disabled={props.loading} onClick={props.onSaveEdits}>
          Save edits and return
        </button>
      )}
      {hideAllContinue ? null : formOwnsContinue ? (
        <button
          type="button"
          className="btn-primary"
          disabled={props.loading || props.continueDisabled === true}
          onClick={props.onContinueForm}
        >
          Continue
        </button>
      ) : hideStepContinue ? null : (
        <button type="button" className="btn-primary" onClick={props.onContinueStep} disabled={props.loading}>
          {props.continueLabel}
        </button>
      )}
    </>
  );
}
